"use strict";
angular.module("wechatQuickPreview", ["wechatDetailModule"]).
controller("wechatQuickPreviewCtrl", ['$scope', '$state', '$stateParams', '$timeout', 'initComDataService', 'trsHttpService', 'localStorageService', '$q', 'trsspliceString', 'resourceCenterService', '$filter', '$compile', 'resCtrModalService', 'globleParamsSet', 'storageListenerService',
    function($scope, $state, $stateParams, $timeout, initComDataService, trsHttpService, localStorageService, $q, trsspliceString, resourceCenterService, $filter, $compile, resCtrModalService, globleParamsSet, storageListenerService) {
        initStatus();
        initData();
        /**
         * [initStatus description] 状态初始化
         */
        function initStatus() {
            //初始化分页参数
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: globleParamsSet.setResourceCenterPageSize,
            };
            //初始化数据
            $scope.data = {
                casDataArea: [], //地区的级联数组/
                themeType: {}, //主题参数
                keyType: {}, //搜索词的类型
                selectedArray: [], //当前的选择项
                currPage: 1, //当前页数
                docType: {
                    data: [],
                    curValue: {}
                }, //稿件类型
                timeType: {}, //时间类型
                rebuildData: []
            };
            $scope.basicParams = {
                channelName: "wx",
                typeName: $stateParams.typename,
                nodeId: $stateParams.nodeid,
            };
            //请求列表的参数,有一些写死的参数
            $scope.params = {
                typeid: "zyzx",
                serviceid: "wx",
                modelId: "findFromNavigation",
                nodeId: $stateParams.nodeid,
                pageSize: $scope.page.PAGESIZE,
                pageNum: $scope.page.CURRPAGE,
                focde: $stateParams.fcode,
                keyword: "",
                typeName: $stateParams.typename
            };
            var paramsArray = $stateParams.param_data.split("&");
            for (var i in paramsArray) {
                var attribute = paramsArray[i].toLowerCase();
                $scope.params[attribute] = $stateParams[attribute];
            }
            //检索词参数
            $scope.keyword = {
                searchType: "0", //查询类型
                keywords: "", //关键词
                time: "", //时间范围
                area: "", //地域
                zyzxfield: "", //主题
                isOriginal: "", //是否原创
                isHead: "", //是否头版
                isRead: "", //是否10w+
                menuscriptType: "" //稿件类型
            };
            $scope.status = {
                channelType: $stateParams.channeltype, //栏目类型
                isSzbPage: false, //是否为数字报版面布局
                screenWrapSelected: false, //是否显示更多筛选
                singleGraph: false, //是否为单图模式
                displayPreview: false,
                isrepetite: false,
                hasphoto: false, //是否显示图集
                isOnly: false, //是否进行排重
                isOriginal: false, //是否原创
                searchShow: false, //是否显示搜索栏
                showRightDetail: false //是否显示右侧详情
            };
        }

        /**
         * [initData description] 数据初始化
         */
        function initData() {
            listenStorage();
            //检索字段
            $scope.data.keyType = {
                data: initComDataService.searchBigdataType(),
                curValue: initComDataService.searchBigdataType()[0]
            };
            initDropDown().then(function() {
                if (angular.isDefined($scope.$root.filterData)) { //判断是否有传递的数据
                    var filterData = angular.copy($scope.$root.filterData);
                    $scope.page = filterData.page;
                    $scope.data.fromdate = filterData.fromdate;
                    $scope.data.untildate = filterData.untildate;
                    $scope.status.isOriginal = filterData.isOriginal;
                    $scope.status.isRead = filterData.isRead;
                    $scope.keyword = $scope.params.keyword = filterData.paramsKeyword;
                    $scope.params.pageNum = $scope.page.CURRPAGE;
                    $scope.params.pageSize = $scope.page.PAGESIZE;
                    $scope.data.docType = filterData.docType; //当前稿件类型
                    $scope.data.keyType = filterData.keyType; //当前检索信息
                    //默认展开更多筛选项
                    if ($scope.data.docType.curValue.value != "0" || $scope.status.isOriginal || $scope.status.isRead || filterData.area != undefined) {
                        $scope.status.screenShow = true;
                    }
                    //默认展开检索信息
                    if ($scope.keyword.keywords != "" || $scope.data.keyType.curValue.value != '0') {
                        $scope.status.searchShow = true;
                    }
                    //地域默认选中项
                    if (filterData.area && filterData.length > 0) {
                        $scope.data.casDataArea.push(filterData.area[0]);
                    }
                    if (filterData.listData) { //是否图集稿，是则直接传递图集列表数据
                        $scope.status.hasphoto = true;
                        $scope.data.items = filterData.listData;
                        $scope.status.singleGraph = filterData.singleGraph; //是否单图
                        storageListenerService.previewPageTurningStorage($scope.data.items, "ZB_GUID", "resourceDetail");
                        if ($scope.data.items.length > 0) {
                            showDetail($scope.data.items[0]); //默认显示第一个文档
                        }
                    } else {
                        requestData();
                    }
                } else {
                    requestData();
                }
                $scope.$root.filterDataBack = angular.copy($scope.$root.filterData);
            });
        }
        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenResource(function() {
                requestData();
                storageListenerService.removeListener("resource");
            }, $scope);
        }
        /**
         * [initDropDown description] 类型下拉框初始化
         * @return {[type]} [description]
         */
        function initDropDown() {
            var defer = $q.defer();
            //检索字段
            $scope.data.keyType = {
                data: initComDataService.searchBigdataType(),
                curValue: initComDataService.searchBigdataType()[0]
            };
            //全部稿件
            var params = {
                typeid: 'zyzx',
                modelid: 'getSearchMenu',
                serviceid: 'wx',
                channelName: 'wx',
                typeName: 'zyzxfield',
                nodeId: 'zyzxfield_001001',
                menuName: 'menuscriptType',
            }
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                $scope.data.docType.data = new Array();
                for (var i = 0; i < data.content[0].length; i++) {
                    $scope.data.docType.data[i] = {
                        name: data.content[0][i].ENNAME,
                        value: data.content[0][i].CNNAME,
                    }
                }
                if ($scope.data.docType.data.length >= 1) {
                    $scope.data.docType.curValue = $scope.data.docType.data[0];
                }
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * [getFilterDataBack description]获取跳转回普通视图存储信息
         * @return {[type]} [description]
         */
        function getFilterDataBack() {
            $scope.$root.filterDataBack = {
                page: $scope.page, //分页
                fromdate: $scope.data.fromdate, //开始时间
                untildate: $scope.data.untildate, //结束时间
                isOriginal: $scope.status.isOriginal, //是否原创
                isRead: $scope.status.isRead, //只看10w+
                docType: $scope.data.docType, //当前稿件类型
                area: $scope.data.area, //地域信息
                paramsKeyword: JSON.parse($scope.params.keyword), //其他条件
                keyType: $scope.data.keyType, //当前检索信息
            };
            if ($scope.status.hasphoto) { //是否图集稿，是则直接传递图集列表数据
                $scope.$root.filterDataBack.listData = $scope.data.items;
                $scope.$root.filterDataBack.singleGraph = $scope.status.singleGraph; //是否单图
            }
            $timeout(function() {
                $scope.$on("$destroy", function() { //销毁对象
                    delete $scope.$root.filterData;
                    delete $scope.$root.filterDataBack;
                });
            });
        }
        /**
         * [requestData description：获取列表数据] 
         */
        function requestData() {
            var defer = $q.defer();
            $scope.keyword.isOriginal = $scope.status.isOriginal ? '1' : '';
            $scope.keyword.isRead = $scope.status.isRead ? '1' : '';
            $scope.params.keyword = JSON.stringify($scope.keyword);
            $scope.loadingPromise = trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), $scope.params, "post").then(function(data) {
                $scope.data.headers = data.summary_info.hybaseField; //表头信息
                $scope.page = data.summary_info; //分页信息
                $scope.basicParams.indexName = data.summary_info.indexName;
                $scope.data.selectedArray = []; //清空之前的选择数据
                /*if (!$scope.status.hasphoto) {
                    $scope.data.items = data.content;
                } else { //图集稿
                    $scope.data.items = $scope.data.items ? $scope.data.items.concat(data.content) : [].concat(data.content);
                }
                if ($scope.data.items.length > 0) {
                    showDetail($scope.data.items[0]); //默认显示第一个文档
                }
                initOperFlag();
                storageListenerService.previewPageTurningStorage($scope.data.items, "ZB_GUID", "resourceDetail");
                getFilterDataBack();*/



                //循环数组 给数据加上序号
                for (var i = 0; i < data.content.length; i++) {
                    data.content[i].NUMBER = (($scope.page.CURRPAGE - 1) * $scope.page.PAGESIZE + i + 1).toString();
                }
                //判断是否是图集稿件
                if (!$scope.status.hasphoto) {
                    $scope.data.items = data.content;
                } else {
                    data.content = $scope.data.items.concat(data.content);
                }
                initOperFlag();
                storageListenerService.previewPageTurningStorage($scope.data.items, "ZB_GUID", "resourceDetail");
                if ($state.params.guid) {
                    showDetail({ ZB_GUID: $state.params.guid });
                } else if ($scope.data.items.length > 0) {
                    showDetail($scope.data.items[0]);
                }
                getFilterDataBack();
                defer.resolve();
            });
            return defer.promise;
        }
        /**
         * 请求图片数据
         * @param {Object} list
         */
        /*function getImgList(list) {
            var docIds = trsspliceString.spliceString(list, "ZB_GUID", ",");
            if (docIds) {
                var params = {
                    typeid: "zyzx",
                    modelid: "getImgList",
                    serviceid: $scope.basicParams.channelName,
                    channelName: $scope.basicParams.channelName,
                    guids: docIds
                };
                trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                    if (data.result == "success") {
                        var temp = data.content[0];
                        var arr = angular.copy(list);
                        for (var i = 0; i < arr.length; i++) {
                            var value = arr[i];
                            if (!value.imgurl) {
                                value.width = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].wight;
                                value.height = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS[0].height;
                                value.imgurl = temp[value.ZB_GUID] && temp[value.ZB_GUID].IMAGEURLS;
                            }
                        }
                        if (!$scope.status.hasphoto) {
                            $scope.data.items = [];
                        }
                        $timeout(function() {
                            if (!$scope.status.hasphoto) {
                                $scope.data.items = arr;
                            } else {
                                $scope.data.items = $scope.data.items ? $scope.data.items.concat(arr) : [].concat(arr);
                            }
                            if ($scope.data.items.length > 0) {
                                showDetail($scope.data.items[0]);
                            }
                            getFilterDataBack();
                        }, 0);
                    }
                });
            }
        }*/
        /**
         * [initOperFlag description] 初始化取签见撤重
         */
        function initOperFlag() {
            var docIds = trsspliceString.spliceString($scope.data.items, "ZB_GUID", ",");
            if (docIds) {
                var params = {
                    methodname: "queryFlag",
                    serviceid: "mlf_bigdataexchange",
                    guids: docIds
                };
                params = angular.extend(params, $scope.basicParams);
                trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "post").then(function(data) {
                    $scope.data.operFlags = [];
                    var temp = data;
                    for (var i in temp) {
                        if (angular.isDefined(data[i]) && data[i].OPERFLAG.indexOf("1") > -1) {
                            $scope.data.operFlags = $scope.data.operFlags.concat(data[i]);
                        }
                    }
                });
            }
        }
        /**
         * @param  {[type]} ChnlDocId  [description] 取签见撤重 点击弹出
         * @param  {[type]} showRepeat [description]
         * @return {[type]}            [description]
         */
        $scope.viewBigDataInfo = function(ChnlDocId, showRepeat, showClick, $event) {
            var operFlags = queryItemBYGUID(ChnlDocId).OPERFLAG;
            var infoModal = resCtrModalService.bigDataInfoModal(ChnlDocId, showRepeat, showClick, operFlags);
            event.stopPropagation();
        };
        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description]
         * @param  {[type]} flagIndex [description]
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex) {
            var temp = queryItemBYGUID(guid);
            if (!!temp) {
                return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == "1" ? true : false;
            } else {
                return false;
            }
        };
        /**
         * [showSelectedArea description：数据地域信息的级联菜单获取数据] 
         * @param {Object} node 选中的节点
         */
        $scope.showSelectedArea = function(node) {
            var deffer = $q.defer();
            var params = {
                serviceid: 'mlf_tenant',
                methodname: 'queryTenantTerritory',
                Territory: node.ID
            };
            trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, 'post').then(function(data) {
                deffer.resolve(data);
            });
            return deffer.promise;
        };

        /**
         * [getDraftType description：获取稿件类型] 
         */
        /*function getDraftType() {
            var defer = $q.defer();
            var params = {
                typeid: 'zyzx',
                modelid: 'getSearchMenu',
                serviceid: 'wx',
                channelName: 'wx',
                typeName: 'zyzxfield',
                nodeId: 'zyzxfield_001001',
                menuName: 'menuscriptType',
            }
            trsHttpService.httpServer(trsHttpService.getBigDataRootUrl(), params, "post").then(function(data) {
                $scope.data.docType.data = new Array();
                for (var i = 0; i < data.content[0].length; i++) {
                    $scope.data.docType.data[i] = {
                        name: data.content[0][i].ENNAME,
                        value: data.content[0][i].CNNAME,
                    }
                }
                if ($scope.data.docType.data.length >= 1) {
                    $scope.data.docType.curValue = $scope.data.docType.data[0];
                }
                defer.resolve();
            });
            return defer.promise;
        }*/
        /**
         * [singleGraphMode description] 是否为单图模式
         * @return {[type]} [description]
         */
        $scope.singleGraphMode = function() {
            $scope.page.CURRPAGE = 1;
            $scope.params.pageNum = $scope.page.CURRPAGE;
            $scope.data.items = [];
            $scope.status.singleGraph = !$scope.status.singleGraph;
            delete $state.params.guid;
            requestData();
        };
        /**
         * [pageChanged description]分页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function() {
            $scope.params.pageNum = $scope.page.CURRPAGE;
            delete $state.params.guid;
            requestData();
        };
        /**
         * [loadMore description] 图集-加载更多
         * @return {[type]} [description]
         */
        $scope.loadMore = function() {
            $scope.params.pageNum++;
            requestData();
        };
        /**
         * [getFilterVal description：获取过滤信息] 
         * @param {Object} key 参数类型
         * @param {Object} val 需要的过滤数据
         */
        $scope.getFilterVal = function(key, val, val2) {
            switch (key) {
                case "area":
                    //获取ID
                    $scope.keyword.area = val[0][val[0].length - 1].ID;
                    $scope.data.area = val;
                    break;
                case "time":
                    //获取开始和结束时间
                    var st = $scope.data.untildate.replace(new RegExp("-", "gm"), "/");
                    var et = $scope.data.fromdate.replace(new RegExp("-", "gm"), "/");
                    if (st == "" && et == "") {
                        $scope.keyword.time = "";
                    } else {
                        $scope.keyword.time = st + "," + et;
                    }
                    if ($scope.status.isrepetite && st == "") {
                        return;
                    }
                    break;
                case "zyzxfield":
                    //获取主题
                    $scope.keyword.zyzxfield = val;
                    break;
                case "doctype":
                    //获取文件类型
                    $scope.keyword.menuscriptType = val;
                    if (val === "2") {
                        $scope.status.hasphoto = true;
                    } else {
                        $scope.status.hasphoto = false;
                    }
                    break;
                case "keyword":
                    //获取文件类型
                    $scope.keyword.keywords = val;
                    $scope.keyword.searchType = $scope.data.keyType.curValue.value;
                    break;
            }
            if ($scope.data.fromdate == "") {
                $scope.status.isrepetite = true;
            } else {
                $scope.status.isrepetite = false;
            }
            clearPageData();
            //刷新列表
            delete $state.params.guid;
            requestData();
        }

        /** 
         * [clearPageData 清楚列表数据]
         */
        function clearPageData() {
            $scope.params.pageNum = 1;
            $scope.data.items = [];
            $scope.status.unloadover = true;
        }

        /**
         * [showOperFlag description] 显示取签见撤重标志
         * @param  {[type]} guid      [description]
         * @param  {[type]} flagIndex [description]
         * @return {[type]}           [description]
         */
        $scope.showOperFlag = function(guid, flagIndex) {
            var temp = queryItemBYGUID(guid);
            if (!!temp) {
                return queryItemBYGUID(guid).OPERFLAG.substr(flagIndex, 1) == "1" ? true : false;
            } else {
                return false;
            }
        };

        /**
         * [queryItemBYGUID description] 根据guid获取在WCM内的取签见撤重的二进制数
         * @param  {[type]} guid [description]
         * @return {[type]}      [description]
         */
        function queryItemBYGUID(guid) {
            for (var i in $scope.data.operFlags) {
                if (guid == $scope.data.operFlags[i].GUID) {
                    return $scope.data.operFlags[i];
                }
            }
        }

        ///////////////////////////////////////////////////////////////////
        /**
         * [showSearch description] 显示隐藏搜索框
         * @return {[type]} [description]
         */
        $scope.showSearch = function() {
            $scope.status.searchShow = !$scope.status.searchShow;
        };
        /**
         * [showScreen description] 显示隐藏更多筛选项
         * @return {[type]} [description]
         */
        $scope.showScreen = function() {
            $scope.status.screenShow = !$scope.status.screenShow;
        };
        /**
         * [showDetail description]展示详情
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.showDetail = function(item) {
            showDetail(item);
        };
        /**
         * [showDetail description] 展示详情
         * @param  {[type]} guid [description]
         * @return {[type]}      [description]
         */
        function showDetail(item) {
            $scope.status.showRightDetail = false;
            $state.params.guid = item.ZB_GUID;
            $state.go($state.current.name, $state.params, { reload: false });
            $scope.data.rebuildData = {
                guid: item.ZB_GUID,
            };
            $timeout(function() {
                $scope.status.curSelected = item.ZB_GUID;
                $scope.status.showRightDetail = true;
            });
        }
        /**
         * [plainView description] 返回 普通视图
         * @return {[type]} [description]
         */
        $scope.plainView = function() {
            $state.go("front.networksource.classifiedresource.wechat.resource", $stateParams);
        };
    }
]);